<template>
    <div container--fluid>
        <v-layout>
            <v-flex xs12>
	            <table id="noticeboard_holder" v-html="noticeTab">
	            </table>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
export default {
    name: 'noticeboard',
    components: {
        //
    },
    data(){
        return {
            noticeTab: ''
        }
    },
    computed: {
        user() {
            return this.$store.getters["user/getProfile"];
        }
    },
    mounted() {
        axios.get("/member/noticeboard").then(response => {
            let noticeboard = response.data.noticeboard;
            let trHTML = '';

            _.forEach(noticeboard, function(val, key) {
                trHTML += '<tr class="tr-section"><td colspan="6">'+key+'</td></tr>';
                _.forEach(val,function(item, i) {
                    trHTML += '<tr><td>' + item.firstname + '</td><td>' + item.surname + '</td><td>' + item.gender + '</td><td>' + item.email + '</td><td>' + item.competition + '</td><td>' + (item.comment ? item.comment : "") + '</td></tr>';
                });
            });

            this.noticeTab = trHTML;
        });
    },
};
</script>

<style>
#noticeboard_holder {
    margin: 30px auto;
}

#noticeboard_holder td {
    padding: 8px 12px;
    vertical-align: initial;
    border: 1px solid #e6e6e6;
    font-size: 13px;
}

#noticeboard_holder .tr-section td {
    text-transform: capitalize;
    background-color: #e6e6e6;
    font-weight: bold;
    padding: 12px !important;
    font-size: 16px !important;
}

@media screen and (max-width: 767px) {
    #noticeboard_holder tr :not(.tr-section) {
        display: flex;
        flex-direction: column;
    }

    #noticeboard_holder tr:nth-child(even) {
        background: #F5F5F5 !important;
    }
}
</style>